import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class RoadmapTableInitiativeUncertaintiesController extends Controller {
  @service store;
  @service initiativeSlideover;

  get openUncertainties() {
    return this.store
      .peekAll('uncertainty')
      .filter(
        (item) =>
          item?.initiative.get('id') === this.model.initiative.id &&
          !item.completed,
      );
  }

  get closedUncertainties() {
    return this.store
      .peekAll('uncertainty')
      .filter(
        (item) =>
          item?.initiative.get('id') === this.model.initiative.id &&
          item.completed === true,
      );
  }

  @action
  handleSettingsSlideoverOpen() {
    this.initiativeSlideover.open(this.model.id);
  }

  @action
  addNewUncertainty() {
    const newButton = document.querySelector('.new-uncertainty-button');
    if (newButton) newButton.click();
  }
}
